import cn from 'classnames';
import React from 'react';
import typeExpression from './utils/jsDocTypeExpression';

var styles = require('./JsDocTypeExpression-styles.module.css');

export default function JsDocTypeExpression(_ref) {
  var type = _ref.type,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("span", {
    className: cn(className, styles.JsDocTypeExpression)
  }, typeExpression(type));
}